import { useSalesTerm } from "@/components/features/items/edit/_shared/ui/components/main/questions/sales-term/hooks";

import * as Shared from "../../../../_shared";

export const useVoucherSalesTerm = () => {
	const { viewModel, onSetViewModel } = Shared.Model.Context.useMarketingVoucherEditContext();
	const { saleTypeForTerm, saleStart, saleEnd } = viewModel;

	const data = useSalesTerm({
		saleTypeForTerm,
		saleStart,
		saleEnd,
		stayableStart: undefined,
		stayableEnd: undefined,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		onSetViewModel: onSetViewModel as any,
	});

	return {
		isEdited: data.isEdited,
		hasError: data.hasError,

		isLimitedSale: data.isLimitedSale,

		saleTypeForTermOptions: data.saleTypeForTermOptions,
		saleTypeForTerm: data.saleTypeForTerm,
		onSetSaleTypeForTerm: data.onSetSaleTypeForTerm,

		saleStart: data.saleStart,
		saleEnd: data.saleEnd,
		onSetSaleTerm: data.onSetSaleTerm,
	};
};
